export default __webpack_public_path__ + "static/media/QA.0f9c41ca.svg";